import { APStudentDetailsQuery } from './../../../global/components/student_details/queries/student_details_query';
class AutoGeneratePlanHeader {
  constructor(private ngAPStudentDetailsQuery: APStudentDetailsQuery) {}
}

angular.module('capability-ng-academic-planner').component('autoGeneratedPlanHeader', {
  controller: AutoGeneratePlanHeader,
  templateUrl:
    'capability-ng-academic-planner/src/advisor_header/components/auto_generated_plan_header/auto_generated_plan_header.html'
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/advisor_header/components/auto_generated_plan_header/auto_generated_plan_header.ts